import type { MediaSoundProcessorOptions } from '@yandex-360/telemost-sdk/device-manager';
import type { SoundProcessorOptions } from '@yandex-video-platform/goloom-sdk';

import { createLogger } from '../../../../helpers/loggerFacade';

const logger = createLogger('goloom:device-manager:sound-processor');

const getGoloomSdkVersionLabel = () => {
    if (typeof GOLOOM_SDK_VERSION === 'undefined') {
        return 'Goloom SDK unknown version';
    }

    return `Goloom SDK ${GOLOOM_SDK_VERSION}`;
};

const isRecord = (value: unknown): value is Record<string, unknown> => {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};

const isSameOptionValue = (value: unknown, mappedValue: unknown): boolean => {
    if (value === mappedValue) {
        return true;
    }

    if (!isRecord(value) || !isRecord(mappedValue)) {
        return false;
    }

    const entries = Object.entries(value);

    return (
        entries.length === Object.keys(mappedValue).length &&
        entries.every(([key, entryValue]) => {
            return mappedValue[key] === entryValue;
        })
    );
};

const getUnsupportedEnabledOptionKeys = (
    options: MediaSoundProcessorOptions,
    mappedOptions: SoundProcessorOptions
): string[] => {
    const mappedOptionByKey = new Map(Object.entries(mappedOptions));

    return Object.entries(options)
        .filter(([key, value]) => {
            return (
                Boolean(value) && (!mappedOptionByKey.has(key) || !isSameOptionValue(value, mappedOptionByKey.get(key)))
            );
        })
        .map(([key]) => key);
};

export const logUnsupportedSoundProcessorOptionsForGoloom = (
    options: MediaSoundProcessorOptions,
    mappedOptions: SoundProcessorOptions,
    method: string
) => {
    const unsupportedOptionKeys = getUnsupportedEnabledOptionKeys(options, mappedOptions);

    if (!unsupportedOptionKeys.length) {
        return;
    }

    logger.error(new Error(`Unsupported sound processor options for ${getGoloomSdkVersionLabel()}`), {
        method,
        additional: {
            unsupportedOptionKeys,
        },
    });
};
